
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';

export const TermsHeader = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <>
      <Helmet>
        <title>Terms of Service - SocialScoop</title>
        <meta name="description" content="Terms of Service for SocialScoop - Diminish the noise, amplify what matters" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Terms of Service - SocialScoop" />
        <meta property="og:description" content="Terms of Service for SocialScoop - Diminish the noise, amplify what matters" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://socialscoop.ai/terms" />
        <meta property="og:site_name" content="SocialScoop" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Terms of Service - SocialScoop" />
        <meta name="twitter:description" content="Terms of Service for SocialScoop - Diminish the noise, amplify what matters" />
        <meta name="tiktok-developers-site-verification" content="lhlaW8lSdiP7B0wucFespFy7vkwZPyvW" />
        <meta name="verification-signature" content="lhlaW8lSdiP7B0wucFespFy7vkwZPyvW" />
        <meta name="document-type" content="terms-of-service" />
        <meta name="site-verification" content="lhlaW8lSdiP7B0wucFespFy7vkwZPyvW" />
        <link rel="canonical" href="https://socialscoop.ai/terms" />
      </Helmet>
      
      {/* Verification signatures for TikTok */}
      <div style={{ display: 'none' }}>
        <span id="tiktok-developers-site-verification">lhlaW8lSdiP7B0wucFespFy7vkwZPyvW</span>
        <span className="verification-signature">lhlaW8lSdiP7B0wucFespFy7vkwZPyvW</span>
        <span data-verify="tiktok">lhlaW8lSdiP7B0wucFespFy7vkwZPyvW</span>
      </div>
      
      <div className="text-center mb-8">
        <button 
          onClick={handleLogoClick}
          className="inline-flex items-center space-x-2 mb-4 hover:opacity-80 transition-opacity cursor-pointer"
        >
          <div className="w-8 h-8 bg-gradient-to-br from-green-600 to-emerald-700 rounded-sm rotate-45 flex items-center justify-center">
            <span className="text-white font-bold text-sm rotate-[-45deg]">S</span>
          </div>
          <span className="text-2xl font-bold text-green-600 tracking-tight hover:text-green-700 transition-colors">SocialScoop.ai</span>
        </button>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Service</h1>
        <p className="text-gray-600">Last updated: {new Date().toLocaleDateString()}</p>
        <div className="hidden" id="verification-signature">lhlaW8lSdiP7B0wucFespFy7vkwZPyvW</div>
        <div style={{ visibility: 'hidden', height: 0, overflow: 'hidden' }}>
          tiktok-developers-site-verification=lhlaW8lSdiP7B0wucFespFy7vkwZPyvW
        </div>
      </div>
    </>
  );
};
